import React, { useState } from "react";
import LandingPage from "./LandingPage";
import SnapLayerSalesLandingV3 from "./SnapLayerSalesLandingV3";
import SnapLayerFeatureLanding from "./SnapLayerFeatureLanding";
import "./RootLanding.css";

type LandingVersion = "v3" | "new" | "classic";

const RootLanding: React.FC = () => {
  // The variant switcher is a team preview tool, not for the public. Gate it behind
  // ?preview (or ?preview=1) so real visitors only ever see the chosen landing page.
  const isPreview =
    typeof window !== "undefined" &&
    new URLSearchParams(window.location.search).has("preview");
  const [landingVersion, setLandingVersion] = useState<LandingVersion>("v3");
  const [showVersionToggle, setShowVersionToggle] = useState(isPreview);

  return (
    <div className="root-landing-shell">
      {isPreview && (showVersionToggle ? (
        <div className="root-landing-toggle" role="region" aria-label="Landing page version toggle">
          <div className="root-landing-toggle-inner">
            <span className="root-landing-toggle-brand">
              <img src="/brand/snaplayer-wordmark-transparent.png" alt="SnapLayer" />
              <span>Homepage preview</span>
            </span>
            <div className="root-landing-toggle-actions">
              <div className="root-landing-switch" role="group" aria-label="Choose landing page version">
                <button
                  type="button"
                  aria-pressed={landingVersion === "v3"}
                  data-active={landingVersion === "v3"}
                  onClick={() => setLandingVersion("v3")}
                >
                  Ver 3
                </button>
                <button
                  type="button"
                  aria-pressed={landingVersion === "new"}
                  data-active={landingVersion === "new"}
                  onClick={() => setLandingVersion("new")}
                >
                  New site
                </button>
                <button
                  type="button"
                  aria-pressed={landingVersion === "classic"}
                  data-active={landingVersion === "classic"}
                  onClick={() => setLandingVersion("classic")}
                >
                  Classic site
                </button>
              </div>
              <button
                type="button"
                className="root-landing-toggle-hide"
                onClick={() => setShowVersionToggle(false)}
                aria-label="Hide homepage version toggle"
              >
                Hide
              </button>
            </div>
          </div>
        </div>
      ) : (
        <button
          type="button"
          className="root-landing-toggle-peek"
          onClick={() => setShowVersionToggle(true)}
          aria-label="Show homepage version toggle"
        >
          Versions
        </button>
      ))}
      {landingVersion === "v3" ? (
        <SnapLayerSalesLandingV3 />
      ) : landingVersion === "new" ? (
        <SnapLayerFeatureLanding />
      ) : (
        <LandingPage />
      )}
    </div>
  );
};

export default RootLanding;
